module.exports = __webpack_public_path__ + "img/4(1).32eef7a6.jpg";